import {
  ChakraCircle,
  ChakraFlex,
  ChakraText,
  ChakraToolTip,
  EquipUITheme,
} from '@equip.health/ui';

const { label: labelStyle } = EquipUITheme.typography;

interface CategoryDisplayProps {
  categoryColor?: string;
  categoryName?: string;
}

const CategoryDisplay = ({
  categoryColor,
  categoryName,
}: CategoryDisplayProps) => (
  <ChakraFlex alignItems="center" height="100%" width="100%">
    {categoryColor && <ChakraCircle background={categoryColor} size="6px" />}
    {categoryName && (
      <ChakraToolTip
        bg="white"
        color="neutral.secondary"
        gutter={3}
        hasArrow
        label={categoryName}
      >
        <ChakraText
          {...labelStyle}
          color="neutral.primary"
          isTruncated
          lineHeight="16.8px"
          paddingLeft={categoryColor ? '4px' : 0}
        >
          {categoryName}
        </ChakraText>
      </ChakraToolTip>
    )}
  </ChakraFlex>
);

export default CategoryDisplay;
